import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Modal, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import CancelIcon from '../../../icons/close.svg';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  onConfirmComplete: (disposition: string) => void;
  workOrderUuid: string;
  disposition?: string;
}
export default function CompleteWorkOrderModal(props: ModalProps) {
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    height: '523px',
    pointerEvents: "auto",
    width: '80%',
    maxWidth: '80%',
    borderRadius: '24px',
    outline: 'none',
  };

  const [disposition, setDisposition] = useState(props.disposition);
  const [dispositionError, setDispositionError] = useState(false);
  const maxCharLength = 5000;
  const handleAddNote = () => {
    if (!disposition) {
      setDispositionError(true);
    } else {
      props.onConfirmComplete(disposition ?? '');
      setDisposition('');
      setDispositionError(false);
    }
  };

  const handleClose = () => {
    setDisposition('');
    setDispositionError(false);
    props.onClose();
  };

  return (
    <Modal
      open={props.open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: false,
      }}
      disableEscapeKeyDown
      disableAutoFocus={true}
    >
      <Card sx={style}>
        <Grid container display="flex" justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: 'Work Sans !important',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '18px !important',
                lineHeight: '21px !important',
                color: '#14142B',
              }}
            >
              Work Completed Detail
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            mt={4}
            sx={{
              '& fieldset': {
                borderRadius: '24px',
                borderColor: 'white',
                height: '384px',
              },
            }}
          >
            <TextField
              multiline
              value={disposition}
              onChange={(e) => {
                setDisposition(e.target.value);
              }}
              rows={15}
              sx={{ width: '100%', backgroundColor: '#F1F0F5', borderRadius: '24px', height: '380px' }}
              placeholder={'Description'}
              error={dispositionError}
              inputProps={{ maxLength: maxCharLength }}
            />
            <Typography
                sx={{
                  fontSize: '14px',
                  textAlign: 'left',
                }}
              >
                {`${disposition?.length ?? 0} / ${maxCharLength}`}
              </Typography>
          </Grid>

          <Box sx={{ position: 'absolute', bottom: 15, width: '94%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <LoadingButton
                variant="contained"
                loading={false}
                style={{
                  textTransform: 'none',
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  backgroundColor: '#39A2DB',
                  borderRadius: '24px',
                }}
                onClick={handleAddNote}
              >
                Close Work Order
              </LoadingButton>
            </Box>
          </Box>

          {/* Close Icon */}
          <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
            <img
              src={CancelIcon}
              alt="close"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                handleClose();
              }}
            />
          </Grid>
        </Grid>
      </Card>
    </Modal>
  );
}
